// extracted by mini-css-extract-plugin
module.exports = {"home":"ReviewTaskListPage-styles-module--home--TZ23q"};